// import $ from 'jquery'
// top level
import $ from 'jquery'
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
// import store from '@/store/index'
// second level
import Welcome from '@/views/Welcome'
import ToWapp from '@/views/ToWapp'
import Home from '@/views/Home'
import Category from '@/views/Category/Category'
import SearchResults from '@/views/search/SearchDetails'
import Cart from '@/views/Cart/Cart'
import Me from '@/views/User/Me'
import Login from '@/views/User/MyLogin/Login'
import Merchandises from '@/views/Detail/Merchandises'
import Orders from '@/views/User/MyOrders/Orders'
import UserInfo from '@/views/User/MyInfo/Userinfo'
import Address from '@/views/User/MyAddress/Address'
import AddressModify from '@/views/User/MyAddress/AddressModify'
import ChangeLoginID from '@/views/User/MyLogin/ChangeLoginID'
import Register from '@/views/User/MyLogin/Register'
import PasswordChange from '@/views/User/MyLogin/PasswordChange'
import MobileLogin from '@/views/User/MyLogin/MobileLogin'
import CategoryDetail from '@/views/Category/CategoryDetail'
import ApplyCreditPay from '@/views/User/MyCredit/ApplyCreditPay'
import MyInvoiceAddress from '@/views/User/MyInvoice/InvoiceAddress'
import AddInvoiceAddress from '@/views/User/MyInvoice/AddInvoiceAddress'
import InvoiceAddressModify from '@/views/User/MyInvoice/InvoiceAddressModify'

import Emkt from '@/emkt'
import OrderContentConfirm from '@/views/Order/OrderContentConfirm'
import OrderContent from '@/views/Order/OrderContent'
import OrderPayConfirm from '@/views/Order/Detail/OrderPayTypeConfirm'
import OrderContentDetail from '@/views/Order/Detail/OrderContentDetail'
import AddressDetail from '@/views/Order/Detail/AddressDetail'
import OrderConfirmDetail from '@/views/Order/Detail/OrderConfirmDetail'
import PayDetail from '@/views/Order/Detail/PayDetail'
import InvoiceDetail from '@/views/Order/Detail/InvoiceDetail'
import Promotions from '@/views/Promotion/Promotions'
import SuccessPay from '@/views/Order/Detail/successPay'
import AddAddress from '@/views/User/MyAddress/AddAddress'
import Activation from '@/views/User/MyLogin/Activation'
import InvoiceTitle from '@/views/User/MyInvoice/InvoiceTitle'
import MyCoupons from '@/views/User/MyCoupons/MyCoupons'
import AddInvoiceTitle from '@/views/User/MyInvoice/AddInvoiceTitle'
import MyOrders from '@/views/MyOrder/order/AllOrder'
import ForgetPassword from '@/views/User/MyLogin/ForgetPassword'
import MyOrderDetail from '@/views/MyOrder/order/detail/OrderDetail'
import Evaluation from '@/views/MyOrder/comment/EvaluationOrder'
import DataMeta from '@/views/DataMeta/DataMeta'
import CustOrder from '@/views/Cust/CustOrder'
import OrderDemo from '@/views/Cust/DiyGoods'
import MyDiscount from '@/views/Order/Detail/MyDiscount'
import MyComment from '@/views/MyOrder/comment/detail/CommentForOrder'
import GetComments from '@/views/MyOrder/comment/detail/GetComments'
import InvoiceAddress from '@/views/Order/InvoiceAddress'
import Message from '@/views/Message/Message'
import Contact from '@/views/Message/Contact'
import MyAgreement from '@/views/User/MyAgreement/MyAgreement'
import MyRecommend from '@/views/User/MyRecommend/MyRecommend'
import publicNumber from '@/views/User/MyRecommend/publicNumber'
import MyOrderCoupons from '@/views/Order/Detail/MyOrderCoupons'
import Compositions from '@/views/Promotion/Compositions'
import CustDetail from '@/views/Cust/Detail/CustDetail'
import CustPriceDetail from '@/views/Cust/Detail/CustPriceDetail'
import MessageManagement from '@/views/Message/MessageManagement'
import Channel from '@/views/Channels/Channel'
import ChannelDetails from '@/views/Channels/ChannelDetails'
import PointsDetails from '@/views/User/MyLogin/PointsDetails'

import Finder from '@/views/finder/Finder'
import FinderMerchandises from '@/views/finder/detail/finderMerchandiseDeail'
import contactUs from '@/views/finder/detail/contactUs'
import FinderOrderDeail from '@/views/finder/detail/finderOrderDeail'

import VipPlanDetails from '@/views/User/MyVipPlan/VipPlanDetails'
import VipPlanMemberDetails from '@/views/User/MyVipPlan/VipPlanMemberDetails'
import MemberDetails from '@/views/User/MyVipPlan/memberDetails'
import PhoneNumberLogin from '@/views/User/MyLogin/PhoneNumberLogin'
import MyAccountChecked from '@/views/User/MyAccountChecked/AllBill.vue'
import ChooseBillType from '@/views/User/MyAccountChecked/ChooseBillType.vue'
import AccountChecked from '@/views/User/MyAccountChecked/AccountChecked.vue'
import OldAccountChecked from '@/views/User/MyAccountChecked/OldAccountChecked.vue'

import SecPromotion from '@/views/Promotion/SecPromotion.vue'
import ResearchMemberCharacterSetting from '@/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberCharacterSetting'
import ResearchGroupHome from '@/views/User/MyResearchGroup/ResearchGroupHome'
import ResearchGroupDetail from '@/views/User/MyResearchGroup/researchGroupManagement/ResearchGroupDetail'
import ResearchMemberManagement from '@/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberManagement'
import ResearchMemberDetail from '@/views/User/MyResearchGroup/researchMemberManagement/ResearchMemberDetail'
import AddResearchMember from '@/views/User/MyResearchGroup/researchMemberManagement/AddResearchMember'
import RegisterContact from '@/views/User/MyResearchGroup/researchMemberManagement/RegisterContact'
import ApproveOrder from '@/views/User/MyResearchGroup/researchGroupManagement/ApproveOrder'
import ApproveOrderDetail from '@/views/User/MyResearchGroup/researchGroupManagement/ApproveOrderDetail'
import BillCheck from '@/views/User/MyResearchGroup/researchGroupBill/BillCheck'
import Benefit from '@/views/User/MyResearchGroup/researchGroupBenefit/Benefit'
import ResearchGroupOrder from '@/views/User/MyResearchGroup/researchGroupProgress/ResearchGroupOrder'
import OrderDetailInfo from '@/views/User/MyResearchGroup/researchGroupProgress/OrderDetailInfo'
import Progress from '@/views/User/MyResearchGroup/researchGroupProgress/ContractProgress'
import ServiceTaskProgress from '@/views/User/MyResearchGroup/researchGroupProgress/ServiceTaskProgress'
import ServiceProgress from '@/views/serviceProgressRefactor/serviceProgress/index.vue'
import HistoryProgressDetail from '@/views/serviceProgressRefactor/historyProgressDetail/index.vue'
import ExperimentDetail from '@/views/serviceProgressRefactor/experimentDetail/index.vue'
import ExpressInfo from '@/views/User/MyResearchGroup/researchGroupProgress/ExpressInfo'
import ActivityDoctor from '@/views/Activities/ActivityDoctor.vue'
import FinderMerchandiseDetailForGR from '@/views/User/MyResearchGroup/researchGroupProgress/FinderMerchandiseDetailForGR'
import OperationResult from '@/views/Activities/GetCoupon/OperationResult.vue'
import SearchContactWithoutDetail from '@/views/Activities/GetCoupon/SearchContactWithoutDetail.vue'
import WeappCouponSelection from '@/views_v_2.6/Order/CouponSelection'
import WeappOrderConfirmation from '@/views_v_2.6/Order/OrderConfirmation'
import WeappAddAddress from '@/views_v_2.6/MyAddress/AddAddress'
import WeappAddress from '@/views_v_2.6/MyAddress/Address'
import WeappAddressModify from '@/views_v_2.6/MyAddress/AddressModify'
import showPdf from '@/views/finder/detail/PdfPreview.vue'
import UpdateInvoiceTitle from '@/views_v_2.6/MyInvoice/updateInvoiceTitle'
import InvoiceTitleModify from '@/views_v_2.6/MyInvoice/InvoiceTitleModify'
// import WeappInvoiceAddress from '@/views_v_2.6/MyInvoice/InvoiceAddress'
// import WeappAddInvoiceAddress from '@/views_v_2.6/MyInvoice/AddInvoiceAddress'
// import WeappInvoiceAddressModify from '@/views_v_2.6/MyInvoice/InvoiceAddressModify'
// import WeappInvoiceTitle from '@/views_v_2.6/MyInvoice/InvoiceTitle'
// import WeappAddInvoiceTitle from '@/views_v_2.6/MyInvoice/AddInvoiceTitle'
// import WeappInvoiceTitleModify from '@/views_v_2.6/MyInvoice/InvoiceTitleModify'
import WeappOrderContentConfirmation from '@/views_v_2.6/Order/OrderContentConfirmation'
import WeappSuccessPay from '@/views_v_2.6/Order/SuccessPay'
import WeappSuccessPay2 from '@/views_v_2.6/Order/SuccessPay2'
import WeappSuccessPay3 from '@/views_v_2.6/Order/SuccessPay3'
import WeappSuccessPay4 from '@/views_v_2.6/Order/SuccessPay4'
import authenticationHome from '@/views/Authentication/authenticationHome.vue'
import sendAuthentication from '@/views/Authentication/sendAuthentication.vue'
import authenticationSuccess from '@/views/Authentication/AuthenticationSuccess.vue'
import ProteomicsPurchase from '../views_fc/Proteomics/Purchase.vue'
import BoSolution from '../views_fc/BoSolution/BoSolution.vue'
import centerController from '../views_fc/centerController'
import PdfList from '../views_fc/BoSolution/PdfList.vue'
import PdfPage from '../views_fc/BoSolution/PdfPage.vue'
import SubmitChecked from '../views_fc/Order/SubmitChecked'
import PromotionSuccess from '../views_fc/Order/PromotionSuccess'
import BuyPromotion from '../views_fc/Promotions/BuyPromotion'
import BoSolutionDetail from '../views_fc/BoSolution/BoSolutionDetail'
import MaterialInquire from '@/views_v_2.6/Material/MaterialInquire'
import SampleDeliveryList from '@/views_v_2.6/Material/SampleDeliveryList'
import MaterialDetail from '@/views_v_2.6/Material/MaterialDetail'
import MaterialSendProcess from '@/views_v_2.6/Material/MaterialSendProcess'
import AddSampleDeliverySheet from '@/views_v_2.6/Material/AddSampleDeliverySheet'
import MySampleDeliverySheet from '@/views_v_2.6/Material/MySampleDeliverySheet'
import DownloadArticleInfoSheet from '@/views_v_2.6/Material/DownloadArticleInfoSheet'
import ComputerSideUsage from '@/views_v_2.6/Material/ComputerSideUsage'
import Anniversary from '../views/Activities/AnnivesaryCoupon/Anniversary'
import emktCommonRoutes from '../emktcommon/router/index.js'
import WeappMyOrders from '@/views_v_2.6/User/myOrders/Orders'
import WeappMyOrderDetail from '@/views_v_2.6/User/myOrders/OrderDetailPage'
import WeappOrderExpress from '@/views_v_2.6/User/myOrders/OrderExpressPage'

Vue.use(Router)

if (Emkt.getUrlParam('ResearchGroup')) {
  Emkt.isResearchGroup = true
}

var router
if (Emkt.isResearchGroup) {
  router = new Router({
    routes: [
      {path: '/login', name: 'login', component: Login, meta: {title: '登录'}},
      {path: '/order/forgetPassword', name: 'forgetPassword', component: ForgetPassword},
      {path: '/PhoneNumberLogin', name: 'PhoneNumberLogin', component: PhoneNumberLogin},
      {path: '/login/register', name: 'register', component: Register},
      {path: '/ResearchGroup/ResearchGroupDetail', name: 'ResearchGroupDetail', component: ResearchGroupDetail},
      {path: '/ResearchGroup/ResearchMemberCharacterSetting', name: 'ResearchMemberCharacterSetting', component: ResearchMemberCharacterSetting},
      {path: '/ResearchGroup/ResearchMemberManagement', name: 'ResearchMemberManagement', component: ResearchMemberManagement},
      {path: '/ResearchGroup/ResearchMemberDetail', name: 'ResearchMemberDetail', component: ResearchMemberDetail},
      {path: '/ResearchGroup/AddResearchMember', name: 'AddResearchMember', component: AddResearchMember},
      {path: '/ResearchGroup/RegisterContact', name: 'RegisterContact', component: RegisterContact},
      {path: '/ResearchGroup/ApproveOrder', name: 'ApproveOrder', component: ApproveOrder},
      {path: '/ResearchGroup/ApproveOrderDetail', name: 'ApproveOrderDetail', component: ApproveOrderDetail},
      {path: '/ResearchGroup/BillCheck', name: 'BillCheck', component: BillCheck},
      {path: '/ResearchGroup/Benefit', name: 'Benefit', component: Benefit},
      {path: '*', name: 'ResearchGroupHome', component: ResearchGroupHome}
    ]
  })
} else {
  router = new Router({
    routes: [
      {path: '/', name: 'welcome', component: Welcome, redirect: '/me'},
      {path: '/toWapp', name: 'ToWapp', component: ToWapp},
      {path: '/home', name: 'home', component: Home, meta: {keepAlive: true, title: '吉凯淘基因'}},
      {path: '/category', name: 'category', component: Category, meta: {keepAlive: true, title: '商品分类'}},
      {path: '/categoryDetail', name: 'categoryDetail', component: CategoryDetail, meta: {keepAlive: false, title: '商品分类'}},
      {path: '/cart', name: 'cart', component: Cart, meta: {keepAlive: true, title: '购物车'}},
      {path: '/detail/merchandises', name: 'merchandises', component: Merchandises, meta: {title: '商品详情'}},
      {path: '/search/results', name: 'searchresults', component: SearchResults},
      {path: '/login', name: 'login', component: Login, meta: {title: '登录'}},
      {path: '/login/register', name: 'register', component: Register},
      {path: '/login/mobileLogin', name: 'mobileLogin', component: MobileLogin},
      {path: '/login/activation', name: 'activation', component: Activation},
      {path: '/me', name: 'me', component: Me, meta: {requireAuth: true}},
      {path: '/me/orders', name: 'orders', component: Orders, meta: {requireAuth: true}},
      // {path: '/me/orders/orderDetail', name: 'orderDetail', component: OrderDetail, meta: {requireAuth: true}},
      {path: '/me/userInfo', name: 'userInfo', component: UserInfo, meta: {requireAuth: true, title: '个人信息'}},
      {path: '/me/userInfo/address/addressModify', name: 'addressModify', component: AddressModify, meta: {requireAuth: true}},
      {path: '/me/userInfo/address', name: 'address', component: Address, meta: {requireAuth: true}},
      {path: '/me/userInfo/address/addAddress', name: 'addAddress', component: AddAddress, meta: {requireAuth: true}},
      {path: '/me/changeLoginId', name: 'changeLoginId', component: ChangeLoginID, meta: {requireAuth: true}},
      {path: '/me/passwordChange', name: 'passwordChange', component: PasswordChange, meta: {requireAuth: true}},
      {path: '/order/orderContentConfirm', name: 'orderContentConfirm', component: OrderContentConfirm},
      {path: '/order/orderPayConfirm', name: 'orderPayConfirm', component: OrderPayConfirm},
      {path: '/order/orderContent', name: 'orderContent', component: OrderContent},
      {path: '/order/addressDetail', name: 'addressDetail', component: AddressDetail},
      {path: '/order/orderConfirmDetail', name: 'orderConfirmDetail', component: OrderConfirmDetail},
      {path: '/order/payDetail', name: 'payDetail', component: PayDetail},
      {path: '/order/invoiceDetail', name: 'invoiceDetail', component: InvoiceDetail},
      {path: '/promotion/promotions', name: 'promotions', component: Promotions},
      {path: '/order/orderContentDetail', name: 'orderContentDetail', component: OrderContentDetail},
      {path: '/detail/successPay', name: 'successPay', component: SuccessPay},
      {path: '/user/invoiceTitle', name: 'invoiceTitle', component: InvoiceTitle},
      {path: '/user/myCoupons', name: 'myCoupons', component: MyCoupons},
      {path: '/user/addInvoiceTitle', name: 'addInvoiceTitle', component: AddInvoiceTitle},
      {path: '/order/myOrder', name: 'myOrders', component: MyOrders},
      {path: '/order/forgetPassword', name: 'forgetPassword', component: ForgetPassword},
      {path: '/order/myOrderDetail', name: 'myOrderDetail', component: MyOrderDetail},
      {path: '/order/orderEvaluation', name: 'evaluation', component: Evaluation},
      {path: '/custOrder', name: 'custOrder', component: CustOrder, meta: {keepAlive: true, title: '定制我的基因产品'}},
      {path: '/custOrder2', name: 'custOrder2', component: OrderDemo, meta: {title: '定制我的基因产品2'}},
      {path: '/dataMeta/dataMeta', name: 'dataMeta', component: DataMeta},
      {path: '/order/MyDiscount', name: 'myDiscount', component: MyDiscount},
      {path: '/order/MyComment', name: 'myComment', component: MyComment},
      {path: '/order/Comments', name: 'getComments', component: GetComments},
      {path: '/order/applyCreditPay', name: 'applyCreditPay', component: ApplyCreditPay},
      {path: '/order/invoiceAddress', name: 'invoiceAddress', component: InvoiceAddress},
      {path: '/user/myInvoice/invoiceAddress', name: 'myInvoiceAddress', component: MyInvoiceAddress},
      {path: '/user/myInvoice/addInvoiceAddress', name: 'addInvoiceAddress', component: AddInvoiceAddress},
      {path: '/user/myInvoice/updateInvoiceTitle', name: 'updateInvoiceTitle', component: UpdateInvoiceTitle, meta: {title: '发票'}},
      {path: '/user/myInvoice/InvoiceTitleModify', name: 'invoiceTitleModify', component: InvoiceTitleModify, meta: {title: '开票信息'}},
      {path: '/user/myInvoice/invoiceAddressModify', name: 'invoiceAddressModify', component: InvoiceAddressModify},
      {path: '/user/myMessage', name: 'myMessage', component: Message, meta: {title: '留言中心'}},
      {path: '/contact', name: 'contact', component: Contact},
      {path: '/user/myAgreement/myAgreement', name: 'myAgreement', component: MyAgreement},
      {path: '/user/myRecommend/myRecommend', name: 'myRecommend', component: MyRecommend},
      {path: '/user/myRecommend/publicNumber', name: 'publicNumber', component: publicNumber},
      {path: '/order/detail/myOrderCoupons', name: 'myOrderCoupons', component: MyOrderCoupons},
      {path: '/promotion/Compositions', name: 'compositions', component: Compositions},
      {path: '/custDetail', name: 'custDetail', component: CustDetail},
      {path: '/CustPriceDetail', name: 'custPriceDetail', component: CustPriceDetail},
      {path: '/MessageManagement', name: 'MessageManagement', component: MessageManagement, meta: {title: '消息管理'}},
      {path: '/Channel', name: 'Channel', component: Channel},
      {path: '/ChannelDetails', name: 'ChannelDetails', component: ChannelDetails},
      {path: '/PointsDetails', name: 'PointsDetails', component: PointsDetails},
      {path: '/finder/finderMerchandises', name: 'finderMerchandises', component: FinderMerchandises},
      {path: '/finer/FinderOrderDeail', name: 'FinderOrderDeail', component: FinderOrderDeail, meta: {title: '订单详情'}},
      {path: '/contactUs', name: 'contactUs', component: contactUs},
      {path: '/finder/search', name: 'finder', component: Finder, meta: {keepAlive: true, title: '吉凯基因产品发现助手'}},
      {path: '/VipPlanDetails', name: 'VipPlanDetails', component: VipPlanDetails},
      {path: '/VipPlanMemberDetails', name: 'VipPlanMemberDetails', component: VipPlanMemberDetails},
      {path: '/MemberDetails', name: 'MemberDetails', component: MemberDetails},
      {path: '/PhoneNumberLogin', name: 'PhoneNumberLogin', component: PhoneNumberLogin},
      {path: '/promotion/secpromotion', name: 'secpromotion', component: SecPromotion},
      {path: '/user/myAccountChecked', name: 'MyAccountChecked', component: MyAccountChecked},
      {path: '/activity/activityDoctor', name: 'ActivityDoctor', component: ActivityDoctor},
      {path: '/detail/operationResult', name: 'OperationResult', component: OperationResult},
      {path: '/detail/SearchContactWithoutDetail', name: 'SearchContactWithoutDetail', component: SearchContactWithoutDetail},
      {path: '/ResearchGroup/ResearchGroupDetail', name: 'ResearchGroupDetail', component: ResearchGroupDetail},
      {path: '/ResearchGroup/ResearchGroupHome', name: 'ResearchGroupHome', component: ResearchGroupHome, meta: {index: 1}},
      {path: '/ResearchGroup/ResearchMemberCharacterSetting', name: 'ResearchMemberCharacterSetting', component: ResearchMemberCharacterSetting},
      {path: '/ResearchGroup/ResearchMemberManagement', name: 'ResearchMemberManagement', component: ResearchMemberManagement},
      {path: '/ResearchGroup/ResearchMemberDetail', name: 'ResearchMemberDetail', component: ResearchMemberDetail},
      {path: '/ResearchGroup/AddResearchMember', name: 'AddResearchMember', component: AddResearchMember},
      {path: '/ResearchGroup/RegisterContact', name: 'RegisterContact', component: RegisterContact},
      {path: '/ResearchGroup/ApproveOrder', name: 'ApproveOrder', component: ApproveOrder},
      {path: '/ResearchGroup/ApproveOrderDetail', name: 'ApproveOrderDetail', component: ApproveOrderDetail},
      {path: '/user/AccountChecked', name: 'AccountChecked', component: AccountChecked},
      {path: '/user/OldAccountChecked', name: 'OldAccountChecked', component: OldAccountChecked, meta: {title: '我的对账单'}},
      {path: '/user/ChooseBillType', name: 'ChooseBillType', component: ChooseBillType},
      {path: '/ResearchGroup/BillCheck', name: 'BillCheck', component: BillCheck},
      {path: '/ResearchGroup/Benefit', name: 'Benefit', component: Benefit},
      {path: '/ResearchGroup/OrderDetailInfo', name: 'OrderDetailInfo', component: OrderDetailInfo},
      {path: '/ResearchGroup/ResearchGroupOrder', name: 'ResearchGroupOrder', component: ResearchGroupOrder, meta: {keepAlive: true, index: 2}},
      {path: '/ResearchGroup/ServiceTaskProgress', name: 'ServiceTaskProgress', component: ServiceTaskProgress},
      {path: '/ResearchGroup/ExpressInfo', name: 'ExpressInfo', component: ExpressInfo},
      {path: '/ResearchGroup/Progress', name: 'Progress', component: Progress},
      {path: '/ResearchGroup/ServiceProgress', name: 'ServiceProgress', component: ServiceProgress, meta: {title: '进展详情'}},
      {path: '/ResearchGroup/HistoryProgressDetail', name: 'HistoryProgressDetail', component: HistoryProgressDetail, meta: {title: '历史进展'}},
      {path: '/ResearchGroup/ExperimentDetail', name: 'ExperimentDetail', component: ExperimentDetail, meta: {title: '实验详情'}},
      {path: '/ResearchGroup/FinderMerchandiseDetailForGR', name: 'FinderMerchandiseDetailForGR', component: FinderMerchandiseDetailForGR},
      {path: '/Weapp/Order/CouponSelection', name: 'WeappCouponSelection', component: WeappCouponSelection, meta: {title: '选择优惠券'}},
      {path: '/Weapp/Order/OrderConfirmation', name: 'WeappOrderConfirmation', component: WeappOrderConfirmation, meta: {title: '下单结算'}},
      {path: '/Weapp/Order/OrderContentConfirmation', name: 'WeappOrderContentConfirmation', component: WeappOrderContentConfirmation, meta: {title: '订单详情'}},
      {path: '/Weapp/Order/SuccessPay', name: 'WeappSuccessPay', component: WeappSuccessPay, meta: {title: '下单成功'}},
      {path: '/Weapp/MyAddress/AddAddress', name: 'WeappAddAddress', component: WeappAddAddress, meta: {title: '新增收货地址'}},
      {path: '/Weapp/MyAddress/Address', name: 'WeappAddress', component: WeappAddress, meta: {title: '收货地址管理'}},
      {path: '/Weapp/MyAddress/AddressModify', name: 'WeappAddressModify', component: WeappAddressModify, meta: {title: '修改收货地址'}},
      // {path: '/Weapp/MyAddress/AddInvoiceAddress', name: 'WeappAddInvoiceAddress', component: WeappAddInvoiceAddress, meta: {title: '新增发票寄送地址'}},
      // {path: '/Weapp/MyInvoice/InvoiceAddress', name: 'WeappInvoiceAddress', component: WeappInvoiceAddress, meta: {title: '发票寄送地址管理'}},
      // {path: '/Weapp/MyInvoice/InvoiceAddressModify', name: 'WeappInvoiceAddressModify', component: WeappInvoiceAddressModify, meta: {title: '修改新增发票寄送地址'}},
      // {path: '/Weapp/MyInvoice/InvoiceTitle', name: 'WeappInvoiceTitle', component: WeappInvoiceTitle, meta: {title: '发票抬头管理'}},
      // {path: '/Weapp/MyInvoice/AddInvoiceTitle', name: 'WeappAddInvoiceTitle', component: WeappAddInvoiceTitle, meta: {title: '新增发票抬头'}},
      // {path: '/Weapp/MyInvoice/InvoiceTitleModify', name: 'WeappInvoiceTitleModify', component: WeappInvoiceTitleModify, meta: {title: '修改发票抬头'}},
      {path: '/Weapp/User/MyOrder/Orders', name: 'WeappMyOrders', component: WeappMyOrders, meta: {title: '我的订单', keepAlive: true}},
      {path: '/Weapp/User/MyOrder/OrderDetail/:orderNo', name: 'WeappMyOrderDetail', component: WeappMyOrderDetail, meta: {title: '我的订单', keepAlive: true}},
      {
        path: '/Weapp/User/MyOrder/OrderDetail/Express/:expressDetail',
        name: 'WeappMyOrderExpress',
        component: WeappOrderExpress,
        meta: { title: '物流信息' }
      },
      ...emktCommonRoutes,
      {path: '/showPdf', name: 'showPdf', component: showPdf},
      {path: '/Weapp/Order/SuccessPay2', name: 'WeappSuccessPay2', component: WeappSuccessPay2, meta: {title: '领取优惠券'}},
      {path: '/Weapp/Order/SuccessPay3', name: 'WeappSuccessPay3', component: WeappSuccessPay3, meta: {title: '领取优惠券'}},
      {path: '/Weapp/Order/SuccessPay4', name: 'WeappSuccessPay4', component: WeappSuccessPay4, meta: {title: '下单抽奖'}},
      {path: '/Weapp/authenticationHome', name: 'authenticationHome', component: authenticationHome, meta: {title: '发起合同签署'}},
      {path: '/Weapp/sendAuthentication', name: 'sendAuthentication', component: sendAuthentication, meta: {title: '签署合同'}},
      {path: '/Weapp/authenticationSuccess', name: 'authenticationSuccess', component: authenticationSuccess, meta: {title: '合同签署成功'}},
      {path: '/centerController', name: 'centerController', component: centerController},
      {path: '/Weapp/Proteomics/Purchase', name: 'proteomicsPurchase', component: ProteomicsPurchase, meta: {title: '选购商品详情'}},
      {path: '/Weapp/BoSolution', name: 'boSolution', component: BoSolution, meta: {title: '样本及实验方案'}},
      {path: '/Weapp/PdfList', name: 'pdfList', component: PdfList, meta: {title: '查看报告'}},
      {path: '/Weapp/PdfPage', name: 'pdfPage', component: PdfPage, meta: {title: '文件下载'}},
      {path: '/success/submitSuccess', name: 'submitSuccess', component: SubmitChecked, meta: {title: '已提交'}},
      {path: '/success/PromotionSuccess', name: 'PromotionSuccess', component: PromotionSuccess, meta: {title: '已提交'}},
      {path: '/BuyPromotion', name: 'BuyPromotion', component: BuyPromotion, meta: {title: '订购协议'}},
      {path: '/Weapp/BoSolutionDetail', name: 'boSolutionDetail', component: BoSolutionDetail, meta: {title: '方案详情'}},
      {path: '/user/Material/MaterialInquire', name: 'MaterialInquire', component: MaterialInquire, meta: {title: '在库实物查询'}},
      {path: '/user/Material/SampleDeliveryList', name: 'SampleDeliveryList', component: SampleDeliveryList, meta: {title: '实物清单', keepAlive: true}},
      {path: '/user/Material/MaterialDetail', name: 'MaterialDetail', component: MaterialDetail, meta: {title: '实物详情', keepAlive: true}},
      {path: '/user/Material/MaterialSendProcess', name: 'MaterialSendProcess', component: MaterialSendProcess, meta: {title: '实物寄送流程'}},
      {path: '/user/Material/AddSampleDeliverySheet', name: 'AddSampleDeliverySheet', component: AddSampleDeliverySheet, meta: {title: '寄送实物', keepAlive: true}},
      {path: '/user/Material/MySampleDeliverySheet', name: 'MySampleDeliverySheet', component: MySampleDeliverySheet, meta: {title: '我的寄送记录', keepAlive: true}},
      {path: '/user/Material/DownloadArticleInfoSheet', name: 'DownloadArticleInfoSheet', component: DownloadArticleInfoSheet, meta: {title: '下载实物信息表'}},
      {path: '/user/Material/ComputerSideUsage', name: 'ComputerSideUsage', component: ComputerSideUsage, meta: {title: '电脑端使用方法'}},
      {path: '/Weapp/activity/anniversary', name: 'anniversary', component: Anniversary, meta: {title: '吉凯22周年回忆录'}}
    ]
  })
}

let params = {}
router.beforeEach((to, from, next) => {
  let custInfo = store.state.sessionInfo.customerInfo
  params['customerNo'] = custInfo ? custInfo.customerNo : 'GUEST'
  params['leaveTime'] = Date.parse(new Date())
  if (from.name && from.name !== null && from.name.indexOf('资讯') > -1) { // '资讯'需要转换成'news'
    params['pageName'] = 'news'
    params['news'] = Emkt.customerBehaviours['news']
  } else {
    params['pageName'] = from.name
    params[from.name] = Emkt.customerBehaviours[from.name]
  }
  // console.log(params)
  if (Emkt.isWapp) {
    window.gcapi('customerBehaviourHandler', params).then(res => {
    })
  }
  Emkt.initCustomerBehaviour() // 初始化
  params = {}
  params['enterTime'] = Date.parse(new Date())
  if (to === undefined) {
    router.app.store.dispatch('navTopLevel', false)
    return
  }
  let toPath = to.path
  // let fromPath = from.path
  // console.log(`to: ${toPath} from: ${fromPath}`)
  if (toPath === '/' || toPath.replace(/[^/]/g, '').length > 1 || Emkt.isResearchGroup) {
    router.app.store.commit('navTopLevel', false)
  } else {
    router.app.store.commit('navTopLevel', true)
  }

  if (to.meta.title) {
    window.document.title = to.meta.title
  } else {
    window.document.title = '吉凯淘基因'
  }
  const toDepth = to.meta ? to.meta.index : 0
  const fromDepth = from.meta ? from.meta.index : 0
  if (toDepth < fromDepth && to.path.indexOf('ResearchGroup') > -1) {
    console.log('后退。。。')
    from.meta.keepAlive = false
    to.meta.keepAlive = true
  }
  // console.log(`navTopLevel: ${router.app.Emkt.navTopLevel}`)
  let enterprisePopupFlag = Emkt.getLocalStorage('enterprisePopupFlag')
  // let invoiceTitlePopupFlag = Emkt.getLocalStorage('invoiceTitlePopupFlag')
  let panelFilterFlag = Emkt.getLocalStorage('panelFilterFlag')
  let panelfinderFlag = Emkt.getLocalStorage('panelfinderFlag')
  if (Emkt.getLocalStorage('isPopUpOpen')) {
    Emkt.setStoreItem('isPopUpOpen', false)
    $.closeModal('.popup-goods')
    next(false)
  } else if (enterprisePopupFlag) {
    $.closeModal('.popup-enterprise')
    next(false)
  } else if (panelFilterFlag) {
    $.closePanel('#panel-right-demo')
    next(false)
  } else if (panelfinderFlag) {
    $.closePanel('#panel-right-finder')
    next(false)
  } else {
    next()
  }
})
router.afterEach(route => {
  // console.log(`成功浏览到: ${route.path}`)
  // Emkt.customerBehaviours['router'] = route
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js